module.exports = __webpack_public_path__ + "static/media/wallfinishes_gwp_60y_n.480dfddb.csv";